import { templateParser } from 'utils/formatString';

export const getAutoProlongText = (content, type, selectedPackage) => templateParser(content[type.toLowerCase()], {
  size: `${selectedPackage.value} ${selectedPackage.unit}`,
  price: `${selectedPackage.priceValue} ${selectedPackage.priceUnit}`,
});
